import React, { useState, useEffect } from 'react';
import axios from 'axios';
const ChatReady = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [categories,setCategories]=useState([]);

  

  const fetchcategories = async () => {
    try {
      const res = await axios.get('https://api.squareandangle.pranatigroup.in/api/admin/chat_ready');
      console.log(res.data);
      setCategories(res.data);
      setError('');
    } catch (e) {
      setError(e.response?.data?.message || 'Load failed');
    }
  };

  const handledelete = async (id) => {
    try {
      await axios.delete(`https://api.squareandangle.pranatigroup.in/api/admin/chat_ready/${id}`);
      fetchcategories();
    } catch (e) {
      setError(e.response?.data?.message || 'Delete failed');
    }
  };
  
  useEffect(() => {
    fetchcategories();
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  const handleOpenModal = () => {
   
    setShowModal(true);
    setError('');
  };
  

  const stylesD = {
    width: "169%",
    paddingRight: "1102px",
    paddingLeft: "15px",
    marginRight: "auto",
    marginLeft: "auto"
  };
  return (
    <>
      {error && <div className="alert alert-danger">{error}</div>}
      <div className="container-fluid" style={isMobile ? {} : stylesD}>
        <div className="d-flex justify-content-between align-items-center mb-3 px-2 w-100">
          <h3 className="m-0">Chat Enquiries</h3>
        </div>
        <div className="table-responsive w-100 p-0">
          <table className="table table-bordered table-striped bg-white w-100 m-0">
            <thead className="thead-dark">
              <tr>
                <th>Serial No</th>
                <th>Mail</th>
                <th>Enquiry</th>
                <th className="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {categories.length > 0 ? (
                categories.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.email}</td>
                    <td>{item.message}</td>
                    <td className="text-center">
                      <button className="btn btn-sm btn-outline-danger" onClick={() => handledelete(item.id)}>
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center text-muted">
                    No chat enquiries found
                  </td>
                </tr>
              )}
            </tbody>

            
           
          </table>
        </div>
      </div>
     
      
    </>
  );
};
export default ChatReady;